module.exports = __webpack_public_path__ + "img/banner-1-new.8f384463.svg";